import {
  SERVICE_CONSUMER_PROMO,
  SERVICE_EVENT_MARKETING,
  SERVICE_SPORT_MARKETING,
} from "../../../const/const";
import ServiceCard from "./service-card";
import "./service-card-list.sass";

const ServiceCardList = () => {
  return (
    <div className="service-card-list">
      <ServiceCard
        title={SERVICE_CONSUMER_PROMO.title}
        name={SERVICE_CONSUMER_PROMO.name}
      >
        {SERVICE_CONSUMER_PROMO.description}
      </ServiceCard>

      <ServiceCard
        title={SERVICE_SPORT_MARKETING.title}
        name={SERVICE_SPORT_MARKETING.name}
      >
        {SERVICE_SPORT_MARKETING.description}
      </ServiceCard>

      <ServiceCard
        title={SERVICE_EVENT_MARKETING.title}
        name={SERVICE_EVENT_MARKETING.name}
      >
        {SERVICE_EVENT_MARKETING.description}
      </ServiceCard>
    </div>
  );
};

export default ServiceCardList;
